/* import __COLOCATED_TEMPLATE__ from './footer.hbs'; */
import { dateTimeFormat } from 'client-portal/utils/date-time';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsNoteDiagnosisTreatmentPlanFooter extends Component {
  dateFormat = dateTimeFormat;
}
